import DashboardSectionCard from "./DashboardSectionCard";
import EmptyState from "./EmptyState";

const FIRM_IMG_BASE = "https://api.firmconnector.com/";
const COLORS = ["#2563EB","#7C3AED","#16A34A","#D97706","#DC2626"];

export default function MyNetwork({ network = [], loading }) {
  return (
    <DashboardSectionCard title="Firms in Network" subtitle="Connected firms" icon="fa-network-wired" colorKey="purple">
      {loading ? (
        [...Array(3)].map((_,i) => (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 0", borderBottom:"1px solid var(--fc-border-light)" }}>
            <div style={{ width:38, height:38, borderRadius:9, background:"var(--fc-border-light)", flexShrink:0 }} />
            <div style={{ flex:1 }}>
              <div style={{ height:11, background:"var(--fc-border-light)", borderRadius:4, width:"60%", marginBottom:5 }} />
              <div style={{ height:9,  background:"var(--fc-bg-light)", borderRadius:4, width:"35%" }} />
            </div>
            <div style={{ width:28, height:20, background:"var(--fc-border-light)", borderRadius:99 }} />
          </div>
        ))
      ) : network.length === 0 ? (
        <EmptyState icon="fa-network-wired" text="No firms yet" sub="Connect with firms to see them here" />
      ) : network.slice(0, 5).map((firm, i) => {
        const name  = firm.firm_name || firm.name || "Unknown";
        const logo  = firm.firm_logo;
        const count = firm.profile_count ?? firm.resource_count ?? firm.candidates ?? 0;
        const color = COLORS[i % COLORS.length];
        const init  = name.charAt(0).toUpperCase();
        const isLast = i === Math.min(network.length, 5) - 1;

        return (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 0", borderBottom:isLast?"none":"1px solid var(--fc-border-light)" }}>

            {/* Logo */}
            <div style={{ width:38, height:38, borderRadius:9, background:logo?"var(--fc-card-bg)":color+"15", border:`1px solid ${logo?"var(--fc-card-border)":color+"25"}`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, overflow:"hidden" }}>
              {logo
                ? <img src={FIRM_IMG_BASE+logo} alt={name} style={{ width:"100%", height:"100%", objectFit:"contain", padding:4 }} onError={e=>e.target.style.display="none"} />
                : <span style={{ fontSize:15, fontWeight:800, color }}>{init}</span>
              }
            </div>

            {/* Name */}
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:13, fontWeight:600, color:"var(--fc-text-primary)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{name}</div>
              <div style={{ fontSize:11, color:"var(--fc-text-subtle)", marginTop:1 }}>
                {count} candidate{count !== 1 ? "s" : ""}
              </div>
            </div>

            {/* Candidate count badge */}
            <div style={{ fontSize:11, fontWeight:700, padding:"3px 9px", borderRadius:99, background:"var(--fc-border-light)", color:"var(--fc-text-secondary)", flexShrink:0 }}>
              {count}
            </div>
          </div>
        );
      })}
    </DashboardSectionCard>
  );
}
